import type { Mark } from '../types'

export const MARKS: Mark[] = ['ok', 'maybe', 'no']

export const MARK_LABEL: Record<Mark, string> = { ok: '○', maybe: '△', no: '✕' }
